import React, { useEffect, useRef, useState } from "react";

// APP COMPONENTS
import PaymentMethodsService from "../../api/paymentMethods";
import { paymentMethodsFrame } from "../../common/frames";
import { cleanSpecialCharacters } from "../../extras";

// MATERIAL UI COMPONENTS
import {
  AutocompleteStyledPaper,
  AutocompleteStyledPopper,
  StyledAutocomplete,
} from "../styled/inputs/autocomplete";
import { StyledTextField } from "../styled/inputs/textInput";

const PaymentMethodFilter = ({ selectedValue, onFilterChange }) => {
  const loadDataAttempts = useRef(0);
  const [paymentMethods, setPaymentMethods] = useState([]);

  useEffect(() => {
    loadData().then((r) => r);
  }, []);

  const loadData = async () => {
    try {
      const res = await PaymentMethodsService.getPaymentMethods();
      const paymentMethodsTreated = res.data.map((paymentMethod) => {
        return {
          label: cleanSpecialCharacters(paymentMethod.title),
          value: paymentMethod.title,
        };
      });

      setPaymentMethods([...paymentMethodsFrame, ...paymentMethodsTreated]);
    } catch (e) {
      console.log(e);
      loadDataAttempts.current += 1;

      if (loadDataAttempts.current < 2) {
        // Retry if less than 2 attempts
        setTimeout(loadData, 1000); // Retry after 1 second
      }
    }
  };

  return (
    <StyledAutocomplete
      disablePortal
      id="payment-methods-values"
      options={paymentMethods}
      getOptionLabel={(option) => option.label}
      groupBy={(option) => option.firstLetter}
      renderInput={(params) => (
        <StyledTextField
          {...params}
          label="Método de Pagamento"
          variant="outlined"
          InputProps={{
            ...params.InputProps,
          }}
        />
      )}
      PopperComponent={(props) => <AutocompleteStyledPopper {...props} />}
      PaperComponent={(props) => <AutocompleteStyledPaper {...props} />}
      onChange={(event, values) => {
        onFilterChange(values);
      }}
      sx={{ mb: 1 }}
    />
  );
};

PaymentMethodFilter.displayName = "Método de Pagamento";

export default PaymentMethodFilter;
